<template>
<div class="d-flex pdt-16 pdb-16">
					<UserImgProfile :data="review.reviewer" :className="'mgr-0'" />
					<div class="flex-grow-1 pdl-18 mgb-4">
						<div class="d-flex">
							<i v-for="i in 5" :key="i"  :class="i <= review.score ? 'material-icons t-color-starmark t-headline8' : 'material-icons t-color-textfieldGuidLine t-headline8'" >star</i>
						</div>
						<div class="t-body1 font-r mgt-4 t-line-2" :class="{'t-color-bodyGrayB': review.isBlocked}">
							{{ review.isBlocked ? $t("3814") : review.content }}
						</div>
						<div class="d-flex mgt-8 align-items-baseline">
							<div class="t-body3  t-color-bodyGrayA font-r mgr-8" :class="{'t-color-bodyGrayB': review.isBlocked}">{{ $t("3437", { first: review.reviewer.name.first, last: review.reviewer.name.last }) }}</div>
							<div class="t-body3 font-r t-color-bodyGrayA mgr-8" :class="{'t-color-bodyGrayB': review.isBlocked}">{{$moment(review.created).fromNow()}}</div>

						</div>
					</div>
				</div>
</template>

<script>
/**
 * 리뷰 목록 아이템 컴포넌트(review list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
	components: {
		UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
	},
	props: ['review'],
	methods: {
	// 학습진행율 데이터 (get learning status data)
		getFirstLetter(name) {
		let firstCharOfName = name.trim().slice(0,1);
		//localStorage.setItem('firstChar', firstCharOfName)
		return firstCharOfName;
		},
		
		getRandomColor(){
			let colors = ['#fb6262', '#d16443d4', '#4d9fd6', '#40bca7', '#9db82f','#76a0d6', '#a967d4', '#696481', '#4c438d', '#fe7947'];
			let randomColor = colors[Math.floor(Math.random() * colors.length)];
			//localStorage.setItem('bgColors', `background-color:${randomColor}`)
			return `background-color:${randomColor}`
		},
	},
}
</script>